export default {
  name: "roi",
  // component: () => import(/* webpackChunkName: "users" */ '@/layouts/PrincipalLayout.vue'),
  children: [
    {
      path: '',
      name: 'roi-index',
      component: () => import( /* webpackChunkName: "privacy-index" */ '@/modules/roi/views/Index.vue'),
    }
  ]
}
